import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export const useButtonName = (button: FlowChartButton) => {
  return `button/${button.id}`
}
